import React, { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import BannerMultiFieldLayout from ".././BannerMultiFieldLayout/BannerMultiFieldLayout";

interface Props {
	stepNumber: number;
}

const BannerMultiFieldList: FC<Props> = ({ stepNumber }) => {
	const { control } = useFormContext<BannerFormState>();

	const fields = useWatch({
		name: `steps.${stepNumber - 1}.fields`,
		control
	});

	// Render radio/style fields after text/URL fields
	const sortedFields = fields
		? [...fields].sort((a, b) => {
				const aIsRadio = a.type === "radio" ? 1 : 0;
				const bIsRadio = b.type === "radio" ? 1 : 0;
				return aIsRadio - bIsRadio;
			})
		: [];

	return (
		<>
			{sortedFields.map((field) => (
				<BannerMultiFieldLayout
					key={field.order}
					stepNumber={stepNumber}
					field={field}
				/>
			))}
		</>
	);
};

export default BannerMultiFieldList;
